import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/trust-center'
)({
  staticData: { pageHeader: { title: 'Trust Center', pad: false } },
})
